import React from 'react';
import { PaymentTypeBadge } from '@/components/PaymentTypeBadge';
import { rs, dmy, STATUS, BUCKET_LABEL } from './vpUtils';

const Th = ({ children, right }) => <th className={`whitespace-nowrap px-3 py-2.5 text-xs font-semibold uppercase tracking-wider text-slate-600 ${right ? 'text-right' : 'text-left'}`}>{children}</th>;
const Td = ({ children, right, className = '' }) => <td className={`whitespace-nowrap px-3 py-2 ${right ? 'text-right' : ''} ${className}`}>{children}</td>;
const Status = ({ s }) => <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${STATUS[s][1]}`}>{STATUS[s][0]}</span>;
const Wrap = ({ children, testId }) => (
  <div className="max-h-[60vh] overflow-auto rounded-xl border border-slate-200 bg-white" data-testid={testId}>
    <table className="w-full text-sm">{children}</table>
  </div>
);
const Empty = ({ cols }) => <tr><td colSpan={cols} className="py-10 text-center text-slate-400">No records for these filters</td></tr>;

export const VPInvoiceTable = ({ rows, onOpen }) => (
  <Wrap testId="vp-invoice-table">
    <thead className="sticky top-0 z-10 bg-slate-50 shadow-[0_1px_0_0_#e2e8f0]"><tr>
      <Th>Vendor Name</Th><Th>Vendor ID</Th><Th>Supplier Invoice</Th><Th>GRN Number</Th><Th>PO Number</Th><Th>Invoice Date</Th>
      <Th>GRN Date</Th><Th>Due Date</Th><Th>Payment Type</Th><Th right>Invoice Value</Th><Th right>Paid</Th><Th right>Outstanding</Th>
      <Th right>Paid %</Th><Th>Status</Th><Th right>Ageing Days</Th><Th>Ageing Bucket</Th><Th>Last Payment</Th></tr></thead>
    <tbody>
      {rows.length === 0 && <Empty cols={17} />}
      {rows.map((r) => (
        <tr key={r.grn_id} onClick={() => onOpen(r)} className="cursor-pointer border-t border-slate-100 hover:bg-blue-50/60" data-testid={`vp-row-${r.grn_id}`}>
          <Td className="font-medium text-slate-800">{r.vendor_name}</Td><Td className="font-mono text-xs">{r.vendor_code}</Td>
          <Td className="font-mono text-blue-700 underline-offset-2 hover:underline">{r.invoice_number || '—'}</Td>
          <Td className="font-mono text-xs">{r.grn_number}</Td><Td className="font-mono text-xs">{r.po_number || '—'}</Td>
          <Td>{dmy(r.invoice_date)}</Td><Td>{dmy(r.grn_date)}</Td>
          <Td className={r.overdue ? 'font-semibold text-red-600' : ''}>{dmy(r.due_date)}{r.overdue && ' · Overdue'}</Td>
          <Td><PaymentTypeBadge type={r.payment_type} /></Td>
          <Td right>{rs(r.invoice_value)}</Td><Td right className="text-emerald-700">{rs(r.amount_paid)}</Td>
          <Td right className={r.outstanding > 0.01 ? 'font-medium text-red-600' : 'text-slate-400'}>{rs(r.outstanding)}</Td>
          <Td right>{r.paid_pct}%</Td><Td><Status s={r.payment_status} /></Td><Td right>{r.ageing_days}</Td>
          <Td>{r.ageing_bucket ? BUCKET_LABEL[r.ageing_bucket] : '—'}</Td><Td>{dmy(r.last_payment_date)}</Td>
        </tr>
      ))}
    </tbody>
  </Wrap>
);

export const VPVendorTable = ({ vendors, onOpen }) => (
  <Wrap testId="vp-vendor-table">
    <thead className="sticky top-0 z-10 bg-slate-50 shadow-[0_1px_0_0_#e2e8f0]"><tr>
      <Th>Vendor Name</Th><Th>Vendor ID</Th><Th right>Invoices</Th><Th right>Invoice Value</Th><Th right>Paid</Th><Th right>Outstanding</Th>
      <Th right>Paid Inv.</Th><Th right>Partial Inv.</Th><Th right>Pending Inv.</Th><Th right>Overdue Inv.</Th></tr></thead>
    <tbody>
      {vendors.length === 0 && <Empty cols={10} />}
      {vendors.map((v) => (
        <tr key={v.vendor_id} onClick={() => onOpen(v)} className="cursor-pointer border-t border-slate-100 hover:bg-blue-50/60" data-testid={`vp-vendor-${v.vendor_id}`}>
          <Td className="font-medium text-blue-700">{v.vendor_name}</Td><Td className="font-mono text-xs">{v.vendor_code}</Td>
          <Td right>{v.invoices}</Td><Td right>{rs(v.invoice_value)}</Td><Td right className="text-emerald-700">{rs(v.paid)}</Td>
          <Td right className={v.outstanding > 0.01 ? 'font-medium text-red-600' : ''}>{rs(v.outstanding)}</Td>
          <Td right>{v.fully_paid}</Td><Td right>{v.partially_paid}</Td><Td right>{v.pending}</Td>
          <Td right className={v.overdue ? 'font-semibold text-red-600' : ''}>{v.overdue}</Td>
        </tr>
      ))}
    </tbody>
  </Wrap>
);
